import React from 'react';

const PLAN_META = {
  free: { label: 'Ücretsiz', color: 'var(--text-muted)', bg: 'var(--surface-2)' },
  starter: { label: 'Başlangıç', color: '#0e7490', bg: 'rgba(8, 145, 178, 0.12)' },
  growth: { label: 'Büyüme', color: '#1d4ed8', bg: 'rgba(37, 99, 235, 0.12)' },
  scale: { label: 'Ölçek', color: '#7c3aed', bg: 'rgba(124, 58, 237, 0.12)' },
  unlimited: { label: 'Sınırsız', color: '#a16207', bg: 'rgba(202, 138, 4, 0.14)' },
};

export default function PlanBadge({ plan, size = 'sm' }) {
  const key = String(plan || 'free').toLowerCase();
  const meta = PLAN_META[key] || PLAN_META.free;
  const padY = size === 'lg' ? '4px' : '2px';
  const padX = size === 'lg' ? '10px' : '6px';
  const fontSize = size === 'lg' ? 12 : 11;
  return (
    <span
      className="inline-flex items-center rounded font-medium"
      style={{
        color: meta.color,
        background: meta.bg,
        border: '1px solid var(--border)',
        padding: `${padY} ${padX}`,
        fontSize,
        letterSpacing: 0.2,
      }}
    >
      {meta.label}
    </span>
  );
}

export function getPlanLabel(plan) {
  return PLAN_META[String(plan || 'free').toLowerCase()]?.label || plan;
}
